/**
 * Scans body tokens for third-level invocations on a known injected
 * dependency — `_field.Property.Method(...)` (e.g. a class property that
 * exposes its own interface implementation, like `_dataHandler.Cache.AddOrUpdate`).
 * Kept separate from CsCallScanner's single-hop scan (that one stays
 * untouched) — only the RAW hit is returned here (targetField/targetType
 * refer to the OUTER field, `_dataHandler`'s own type); resolving
 * `Property`'s declared type and continuing the call chain into it is the
 * caller's job (see CsSeqOrchestrator.resolveThirdLevelCalls), so this stays
 * a pure token scan.
 * @param {{type: string, value: string}[]} bodyTokens
 * @param {Map<string, string>} fieldTypeMap - field name -> declared type, from the caller's constructor dependencies
 * @returns {{targetField: string, targetType: string, intermediateProperty: string, targetMethodName: string}[]}
 */
export function scanThirdLevelInvocations(bodyTokens, fieldTypeMap) {
  const calls = [];
  for (let i = 0; i < bodyTokens.length - 5; i += 1) {
    const field = bodyTokens[i];
    const dot1 = bodyTokens[i + 1];
    const property = bodyTokens[i + 2];
    const dot2 = bodyTokens[i + 3];
    const method = bodyTokens[i + 4];
    const paren = bodyTokens[i + 5];
    if (
      field.type === 'identifier' &&
      fieldTypeMap.has(field.value) &&
      dot1.value === '.' &&
      property.type === 'identifier' &&
      dot2.value === '.' &&
      method.type === 'identifier' &&
      paren.value === '('
    ) {
      calls.push({
        targetField: field.value,
        targetType: fieldTypeMap.get(field.value),
        intermediateProperty: property.value,
        targetMethodName: method.value,
      });
    }
  }
  return calls;
}
